<!-- No money moving (a gate pass), or the list has not loaded: ask nothing rather than guess. -->
<div class="tm-choice" *ngIf="asks">
  <div class="tm-label">How is this {{ what }} being paid?</div>

  <!-- FIRST QUESTION — cash, swiped, mobile money? A group of one picks straight through: a cashier
       should not have to tap "CASH" and then "CASH" again. -->
  <div class="tm-opts" *ngIf="openGroup === null">
    <button *ngFor="let g of groups" type="button" class="tm-opt"
            [class.is-picked]="isGroupPicked(g)" [disabled]="disabled" (click)="pickGroup(g)">
      <span class="tm-logos" *ngIf="!opens(g) && logosFor(methodsIn(g)[0]).length">
        <img *ngFor="let src of logosFor(methodsIn(g)[0])" [src]="src" alt="" class="tm-logo" />
      </span>
      <i *ngIf="!opens(g) && !logosFor(methodsIn(g)[0]).length" class="bi {{ iconFor(methodsIn(g)[0]) }}"></i>
      {{ g }}
      <i *ngIf="opens(g)" class="bi bi-chevron-right tm-chev"></i>
    </button>
  </div>

  <!-- SECOND QUESTION — which wallet. The wallet is what gets STORED: each one settles into its own
       merchant account, so a receipt saying only "MOBILE MONEY" could not be reconciled. -->
  <div *ngIf="openGroup !== null">
    <div class="tm-sublabel">
      <button type="button" class="tm-back" (click)="closeGroup()">
        <i class="bi bi-chevron-left"></i> {{ openGroup }}
      </button>
      — which one?
    </div>
    <div class="tm-opts">
      <button *ngFor="let m of openChoices" type="button" class="tm-opt"
              [class.is-picked]="isPicked(m)" [disabled]="disabled" (click)="pick(m)">
        <span class="tm-logos" *ngIf="logosFor(m).length">
          <img *ngFor="let src of logosFor(m)" [src]="src" alt="" class="tm-logo" />
        </span>
        <i *ngIf="!logosFor(m).length" class="bi {{ iconFor(m) }}"></i>
        {{ m }}
      </button>
    </div>
  </div>

  <!-- Nothing is pre-picked on purpose: defaulting to CASH would quietly assert the money is in a
       drawer, which is the exact claim the end-of-day cash-up exists to check. -->
  <div class="tm-hint" *ngIf="!answered">
    Needed so the end-of-day cash-up can tell the drawer from the bank.
  </div>
  <div class="tm-picked" *ngIf="answered">
    <i class="bi bi-check2"></i>
    {{ value }}<span *ngIf="pickedGroup && pickedGroup !== value"> ({{ pickedGroup }})</span>
  </div>
</div>
